import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as detallePedidoActions from '../../reducers/DetallePedidoReducer/actions';
import * as pedidoActions from '../../reducers/PedidoReducer/actions';
import * as layoutActions from '../../reducers/LayoutReducer/actions';
import * as configGlobalActions from '../../reducers/ConfigGlobalReducer/actions';
import { instalacionSelector, usuarioSelector } from '../../selectors/sessionSelector';
import { pedidoDataSelector } from '../../selectors/pedidoSelector';
import { configVidrieraSelector } from '../../selectors/configGlobalSelector';
import ProductoDetalleComponent from '../../components/ProductoDetalle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { productPath } from '../../utils';

class ProductoDetalleContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cargando: true,
            cantidadPedido: 0,
            showAlternativas: false,
            cantidadInicialAlternativas: 0,
            cargandoRelacionados: true
        };
        this.timeouts = [];
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.detalleProductoHabilitado()) {
            this.fetchData();
        } else if (this.props.instalacion) {
            this.redirigirAlCatalogo();
        }
        this.props.setShowResumenPedido(true);
        this.props.setPermiteUsuarioAnonimo(true);
        this.props.showBusqueda(true);
        
        if (!this.props.configVidriera) {
            this.props.fetchConfigVidriera();
        }

        if (this.props.usuario && this.props.usuario.id) {
            this.props.sagaFetchPedidoBorrador({ idUsuario: this.props.usuario.id });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.error) {
            this.redirigirAlCatalogo();
            return;
        }

        if (!this.detalleProductoHabilitado()) {
            this.redirigirAlCatalogo();
            return;
        }

        this.actualizarUrlCanonica();

        if (prevProps.match.params.idArticulo !== this.props.match.params.idArticulo) {
            window.scrollTo(0, 0);
            this.fetchData();
            this.setState({ cantidadPedido: 0, cargandoRelacionados: true });
        } else if (!prevProps.instalacion && this.props.instalacion) {
            this.fetchData();
        }

        if (prevProps.articulosRelacionados !== this.props.articulosRelacionados) {
            this.setState({ cargandoRelacionados: false });
        }

        // Sincronizar la cantidad local con la del carrito si cambia el pedido global
        const prevCantidad = this.getCantidadDesdePedido(prevProps, prevProps.articulo);
        const nextCantidad = this.getCantidadDesdePedido(this.props, this.props.articulo);
        
        if (prevCantidad !== nextCantidad) {
            this.setState({ cantidadPedido: nextCantidad });
        }
    }

    getCantidadDesdePedido = (props, articulo) => {
        if (props.dataPedido && props.dataPedido.pedido && props.dataPedido.pedido.listaPedidoDetalle && articulo) {
            const idArt = articulo.idArticulo || articulo.id;
            const item = props.dataPedido.pedido.listaPedidoDetalle.find(x => 
                Number(x.idArticulo) === Number(idArt)
            );
            return item ? item.cantidad : 0;
        }
        return 0;
    }

    detalleProductoHabilitado = () => {
        return !this.props.instalacion || this.props.instalacion.habilitarPaginaProducto !== false;
    }

    redirigirAlCatalogo = () => {
        if (this.props.history.location.pathname !== '/') {
            this.props.history.replace('/');
        }
    }

    actualizarUrlCanonica = () => {
        const { articulo, match, history } = this.props;
        const idArticulo = articulo && (articulo.idArticulo || articulo.id);

        if (!idArticulo || String(idArticulo) !== String(match.params.idArticulo)) {
            return;
        }

        const canonicalPath = productPath(idArticulo, articulo.nombre);
        if (history.location.pathname !== canonicalPath) {
            history.replace(canonicalPath);
        }
    }

    componentWillUnmount() {
        this.props.setShowResumenPedido(false);
        this.props.setPermiteUsuarioAnonimo(false);
        this.props.showBusqueda(false);
        this.props.initializeFormDetallePedido();
    }

    fetchData = () => {
        if (!this.detalleProductoHabilitado()) {
            return;
        }

        const idArticulo = this.props.match.params.idArticulo;
        const { instalacion } = this.props;
        if (idArticulo && instalacion && instalacion.id) {
            this.setState({ cargandoRelacionados: true });
            this.props.sagaFetchArticulo({ idArticulo, idInstalacion: instalacion.id });
            this.props.sagaFetchArticulosRelacionados({ idArticulo });
        }
    }

    handleAgregarQuitarUnidad = (cantidad, articulo, alternativa) => {
        if (!this.props.usuario || !this.props.usuario.id) {
            window.location.hash = "/Login";
            return;
        }

        // Actualizamos el estado local inmediatamente para que la UI responda
        this.setState({ cantidadPedido: cantidad, showAlternativas: false });

        // Limpiamos timeouts previos (debounce)
        for (let i = 0; i < this.timeouts.length; i++) {
            clearTimeout(this.timeouts[i]);
        }
        this.timeouts = [];

        this.timeouts.push(setTimeout(() => {
            if (this.state.cantidadPedido !== cantidad) return; // Evitar llamadas si cambió de nuevo

            if (cantidad === 0) {
                if (this.props.dataPedido && this.props.dataPedido.pedido && this.props.dataPedido.pedido.listaPedidoDetalle) {
                    const idArt = articulo.idArticulo || articulo.id;
                    let pedidoDetalle = this.props.dataPedido.pedido.listaPedidoDetalle.filter(
                        (x) => Number(x.idArticulo) === Number(idArt)
                    );

                    if (pedidoDetalle.length > 0) {
                        let payload = {
                            idPedido: this.props.dataPedido.pedido.id,
                            idUsuario: this.props.usuario.id,
                            idPedidoDetalle: pedidoDetalle[0].idPedidoDetalle,
                        };
                        this.props.sagaRemovePedidoDetalle(payload);
                    }
                }
            } else {
                let addPedidoModel = {
                    idInstalacion: this.props.instalacion.id,
                    idCliente: this.props.usuario.idCliente,
                    usuarioRegistro: this.props.usuario.id,
                    Items: [{
                        alternativa,
                        cantidad,
                        idArticulo: articulo.idArticulo || articulo.id,
                        idCatalogoEntrada: articulo.idCatalogoEntrada,
                    }]
                };

                if (this.props.dataPedido && this.props.dataPedido.pedido !== undefined) {
                    this.props.setTimerReiniciar(true);
                }

                this.props.sagaAddPedidoDetalle(addPedidoModel);
            }
        }, 1000));
    };

    onChangeCantidad = (cantidad) => {
        if (!this.props.usuario || !this.props.usuario.id) {
            window.location.hash = "/Login";
            return;
        }

        const { articulo, dataPedido } = this.props;
        
        // Buscamos si el artículo ya está en el pedido
        let detallePedidoArticulo;
        let alternativa;
        if (dataPedido && dataPedido.pedido) {
            const idArt = articulo.idArticulo || articulo.id;
            detallePedidoArticulo = dataPedido.pedido.listaPedidoDetalle.find((x) => 
                Number(x.idArticulo) === Number(idArt)
            );
            if (detallePedidoArticulo) {
                alternativa = detallePedidoArticulo.alternativa;
            }
        }

        const articuloTieneAlternativas = articulo.articuloAlternativas && articulo.articuloAlternativas.length > 0;
        // Solo mostramos alternativas si el artículo las tiene y NO está ya en el carrito
        const mostrarAlternativas = articuloTieneAlternativas && !detallePedidoArticulo && cantidad > 0;

        if (mostrarAlternativas) {
            this.setState({ showAlternativas: true, cantidadInicialAlternativas: cantidad });
        } else {
            this.handleAgregarQuitarUnidad(cantidad, articulo, alternativa);
        }
    };

    handleCloseAlternativas = () => {
        this.setState({ showAlternativas: false });
    };

    render() {
        const { articulo, error, instalacion, usuario, dataPedido, configVidriera } = this.props;
        if (error) {
            return null;
        }

        const loading = !articulo || !instalacion || configVidriera === null || configVidriera === undefined;

        const cantidadEnCarrito = this.state.cantidadPedido;

        return (
            <ProductoDetalleComponent
                articulo={articulo || {}}
                instalacion={instalacion || {}}
                usuario={usuario}
                configVidriera={this.props.configVidriera}
                cantidadEnCarrito={cantidadEnCarrito}
                handleAgregarQuitarUnidad={this.handleAgregarQuitarUnidad}
                onChangeCantidad={this.onChangeCantidad}
                showAlternativas={this.state.showAlternativas}
                cantidadInicialAlternativas={this.state.cantidadInicialAlternativas}
                handleCloseAlternativas={this.handleCloseAlternativas}
                loading={loading}
                productosRelacionados={this.props.articulosRelacionados}
                loadingRelacionados={this.state.cargandoRelacionados}
            />
        );
    }
}

function mapStateToProps(state) {
    const data = state.detallePedidoReducer.get('data').toJS();
    return {
        articulo: data.articulo,
        articulosRelacionados: data.articulosRelacionados,
        error: state.detallePedidoReducer.get('error'),
        instalacion: instalacionSelector(state),
        usuario: usuarioSelector(state),
        dataPedido: pedidoDataSelector(state),
        configVidriera: configVidrieraSelector(state)
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ...detallePedidoActions,
        ...pedidoActions,
        ...layoutActions,
        ...configGlobalActions
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductoDetalleContainer));
